import React from 'react';
import {ContextAggregate} from 'Context';
import {Kontakt, ProduktListe} from './ui';

function App() {
    return (
        <ContextAggregate>
            <div className='container'>
                <div className='bookmark-overview'>
                    <div className='bookmark-overview__textblock'>
                        <div className='textblock textblock--text-large'>
                            <h1>Merkliste</h1>
                            <p>Hier erhalten Sie eine Übersicht aller Produkte, die Sie sich vorgemerkt haben.</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-md-6 col-lg-8'>
                            <ProduktListe/>
                        </div>
                        <div className='col-12 col-md-6 col-lg-4'>
                            <Kontakt/>
                        </div>
                    </div>
                </div>
            </div>
        </ContextAggregate>
    );
}

export default App;
